<div [class.isPrinting]="printService.isPrinting">
  <ngx-spinner bdColor="rgba(0,0,0,0)"
               size="medium"
               color="#000000"
               type="ball-spin-clockwise">
  </ngx-spinner>

  <div class="row my-profile-form">



    <div class="columninvoice padding-left-15px">
      <div class="card height-100vh ">
        <!--<div class="card-header wh-header  padding-bottom-0px padding-left-0px padding-right-0px padding-t-6px ">
          <div class="row border-bottom padding-bottom-5px margin-left-0px margin-right-0px">
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-5 padding-right-0px">
                  <label class="margin-bottom-0px margin-left-5px">New Goods Inward</label>
                </div>
                <div class="col-md-5 padding-left-0px padding-right-7px">
                  <CustomDataByRequestType RequestedType="AccessibleStores" FacilityCode={{FacilityCode}} ActorCode={{ActorCode2}} class="form-group margin-bottom-0px" SelectedValue="StoreCode"
                                           [(ngModel)]="StoreCode" (keyChange)="onAssignedToActorCodesurgeon2($event)"
                                           name="StoreCodename" #sign2="ngModel">
                  </CustomDataByRequestType>

                </div>
                <div class="col-md-1 padding-left-0px">
                  <label class="margin-bottom-0px font-size-14">(TO)</label>
                </div>
              </div>


              <label *ngIf="StoreCode==0 && Prescribercode==0" class="color-Assign font-size-14">(Select Store & Prescriber)</label>
              <label *ngIf="Prescribercode==0" class="color-Assign font-size-14">(Select Store)</label>
            </div>


            <div class="col-md-6 float-right">
              <div class="row">
                <div class="col-md-4 padding-right-0px" hidden>
                  <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                </div>
                <div class="offset-md-4 col-md-8 padding-left-0px" *ngIf="ChargeEntryCodeModal==0">
                  <button type="button" class="btn btn-secondary float-right  font-size-13px margin-left-5px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="Cancel()" *ngIf='isvisible'>Back</button>
                  <div *canUserAccess="['HL_BL_13']">
                    <button class="btn actions-btn-prime font-size-13px margin-left-5px float-right" (click)="Payment()" *ngIf="LChargeEntryCode!=0 && !istextshow"><i class="fas fa-rupee-sign nav-link-hand font-size-12px margin-top-5px"></i> Pay</button>
                  </div>
                  <div *canUserAccess="['HL_BL_12']">
                    <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" (click)="AddData()" *ngIf='isvisible'>Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                  </div>
                  <label class="margin-bottom-0px font-size-12px color-Rejected margin-left-5px" *ngIf="istextshow">Check Item Quantity</label>

                </div>
                <div class="col-md-8 padding-left-0px" *ngIf="ChargeEntryCodeModal>0">
                  <div class="row">
                    <div class="col-md-6">

                  </div>
                    <div class="offset-md-4 col-md-8">
                      <button class="btn actions-btn-prime font-size-13px margin-left-5px float-right" (click)="Cancel()">View Bills</button>
                      <a *canUserAccess="['HL_BL_16']" class="nav-link-hand education-navlink data-color-new float-right margin-top-5px" (click)="rxbill()" title="print">
                        <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                      </a>
                    </div>
                  </div>

                </div>
              </div>
              <button type="submit" class="btn actions-btn-prime font-size-13px margin-left-5px float-right"><i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> Print</button>



            </div>

          </div>
          <div class="row border-top border-bottom bk-color-light margin-left-0px margin-right-0px">

          </div>
        </div>-->
        <div class="card-body  padding-bottom-0px padding-left-0px padding-right-0px padding-top-0px margin-left-0px">
          <div class="row margin-left-0px  margin-top-5px margin-bottom-5px">
            <div class="col-md-3 padding-right-0px">
              <label class="margin-bottom-0px">Present Treatment Category</label>
            </div>:
            <div class="col-md-2">
              <h4 class="margin-bottom-0px color-Assign font-weight-bold margin-top-5px">{{TreatmentCategory}}</h4>
            </div>
            <div class="col-md-1 padding-left-0px">
              <button type="button"
                      (click)="AddCategory()"
                      *ngIf="AdmissionHeader2 && !AdmissionHeader2.IsDischarged"
                      class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3" title="Click Here to Change Treatment Category"> <i class="fas fa-ellipsis-h"></i></button>
            </div>
            <div class="col-md-5 padding-left-0px">
              <div class="display-inline" *canUserAccess="['HL_ADT_GEN_BILL']">
                <button type="button"
                        *ngIf="AdmissionHeader2 && !AdmissionHeader2.IsDischarged"
                        (click)="GenerateBill()"
                        class="btn btn-profile actions-btn-prime-profile2 nav-link-hand font-size-13px margin-right-5px">
                  Generate Bill
                </button>
              </div>
              <div class="display-inline" *canUserAccess="['HL_ADT_GEN_LABORD']">
                <button type="button"
                        *ngIf="AdmissionHeader2 && !AdmissionHeader2.IsDischarged"
                        (click)="GenerateLabOrder()"
                        class="btn btn-profile actions-btn-prime-profile2 nav-link-hand font-size-13px margin-right-5px">
                  Generate Lab Order
                </button>
              </div>
              <!--<div class="display-inline">
                <button type="button" class="btn btn-profile actions-btn-prime-profile2 nav-link-hand font-size-13px margin-right-5px">
                  Remove IP Advance
                </button>
              </div>-->
            </div>
          </div>



          <div class="chatsd product-chart-wrapper agreement-chart-wrapper ps2 padding-lrt height-80pe">
            <div class="row padding-top-3px margin-left-0px">
              <div class="col-md-12 padding-left-0px">
                <div class="table-component">
                  <div class="table-responsive overflow-x">


                    <table class="table table-striped margin-left-15px"
                           cols="auto,2*,*,*,*,*,*,*">

                      <thead class="">
                        <tr>

                          <th class="min-width-24px padding-bottom-4px padding-top-4px">
                            #
                          </th>
                          <th class="padding-top-4px padding-bottom-4px">
                            Date
                          </th>
                          <!--<th class="padding-top-4px padding-bottom-4px">

  </th>-->

                          <th class="padding-top-4px padding-bottom-4px">
                            Service Description
                          </th>
                          <!--<th class="padding-top-4px padding-bottom-4px">

  </th>-->
                          <th class="text-align-center padding-right-0px padding-top-4px padding-bottom-4px">
                            QTY
                          </th>
                          <th class="text-align-center padding-right-0px padding-top-4px padding-bottom-4px">
                            Price
                          </th>
                          <th class=" padding-right-0px padding-top-4px padding-bottom-4px">
                            Provider
                          </th>
                          <th class=" padding-right-0px padding-top-4px padding-bottom-4px">
                            Treatment Category
                          </th>



                          <th class="">

                          </th>







                        </tr>
                      </thead>

                      <tbody class="table-body">
                        <tr *ngFor="let l of CurrentAdmissionServicesController;let RowIndex = index">


                          <td class="td-padding-tb">

                            {{RowIndex+1}}
                          </td>
                          <td class="td-padding-tb">

                            {{l.PlannedServiceDate | date:'dd-MMM-yyyy'}}
                          </td>
                          <!--<td class=" td-padding-tb padding-left-0px paddig-right-0px">

                            <button type="button" class="font-size-16px color-secondary nav-link-hand border-all-0px" title="ServiceTracking"><i class="fas fa-ellipsis-h"></i></button>
                            <a data-toggle="tooltip" data-placement="bottom" title="Planned" class="margin-left-5px">

                              <i class="fas fa-circle color-green  nav-link-hand font-size-14">
                              </i>
                            </a>
                          </td>-->
                          <td class=" td-padding-tb">
                            <a data-toggle="tooltip" data-placement="bottom" title="UNBILLED" *ngIf="l.ItemStatus=='UNBILLED'">

                              <i class="fas fa-circle color-Rejected  nav-link-hand font-size-10px">
                              </i>
                            </a>
                            <a data-toggle="tooltip" data-placement="bottom" title="BILLED" *ngIf="l.ItemStatus=='BILLED'">

                              <i class="fas fa-circle color-blue  nav-link-hand font-size-10px">
                              </i>
                            </a>
                            <a data-toggle="tooltip" data-placement="bottom" title="PAID" *ngIf="l.ItemStatus=='PAID'">

                              <i class="fas fa-rupee-sign color-green  nav-link-hand font-size-10px">
                              </i>
                            </a>
                            {{l.Details}}
                          </td>

                          <td class="text-align-center td-padding-tb padding-right-0px">{{l.Quantity}}</td>
                          <td class="text-align-center td-padding-tb padding-right-0px">{{l.UnitPrice}}</td>
                          <td class=" td-padding-tb padding-right-0px">{{l.ProviderName}}</td>
                          <td class=" td-padding-tb padding-right-0px">{{l.TreatmentCategory}}</td>

                          <td>
                            <div class="display-inline" *canUserAccess="['HL_ADMN_SVC_ITEM_EDIT']">
                              <a (click)="EditServices(l)"
                                 *ngIf="AdmissionHeader2 && !AdmissionHeader2.IsDischarged"
                                 class="nav-link-hand education-navlink" tooltip="Edit">
                                <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                              </a>
                            </div>
                            <div class="display-inline" *canUserAccess="['HL_ADMN_SVC_ITEM_DELETE']">
                              <a (click)="DeleteMaterial(l)"
                                 *ngIf="AdmissionHeader2 && !AdmissionHeader2.IsDischarged"
                                 class="nav-link-hand font-size-14 color-Rejected" title="Remove">
                                <i class="far fa-trash-alt nav-link-hand"></i>
                              </a>
                            </div>
                          </td>
                          
                        </tr>

                      </tbody>



                    </table>
                  </div>
                </div>
              </div>
            </div>





            <!--<div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <div class="card">


                  <div class="card-header wh-header border-bottom padding-bottom-0px">
                    <div class="row border-bottom">
                      <div class="col-md-12">
                        <label class="margin-bottom-0px">Payment</label>
                      </div>

                    </div>
                  </div>
                  <div class="card-body padding-top-5px padding-bottom-0px">
                    <div class="row">

                        <div class="col-md-12 padding-right-0px">
                          <div class="table-component">
                            <div class="table-responsive">


                              <table class="table table-striped margin-left-zero width-100">

                                <thead class="">
                                  <tr>

                                    <th class="min-width-0px"></th>
                                    <th class="th-width-170px">Amount</th>

                                    <th class="th-width-170px">Charges</th>
                                    <th class="th-width-170px">Ref.No</th>
                                    <th>Details</th>
                                  </tr>
                                </thead>
                                <tbody class="table-body">

                                  <tr>
                                    <td class="td-padding">

                                        <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                               [(ngModel)]="cash" />
                                        <i class="input-helper"></i>

                                        <label class="margin-bottom-0px position-absoulte margin-top-2px">Cash</label>



                                    </td>
                                    <td>
                                      <input type="text" class="form-control"
                                             min="1" max="10" *ngIf="cash">
                                    </td>
                                    <td class="text-align-right">
                                      <input type="text" class="form-control"
                                             min="1" max="10" *ngIf="cash">
                                    </td>

                                    <td class="td-padding ">

                                      <input type="text" class="form-control"
                                             min="1" max="10" *ngIf="cash">

                                    </td>

                                    <td>
                                      <input type="text" class="form-control"
                                             min="1" max="10" *ngIf="cash">
                                    </td>



                                  </tr>
                                  <tr>
                                    <td class="td-padding">

                                      <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                             [(ngModel)]="card" />
                                      <i class="input-helper"></i>
                                      <label class="margin-bottom-0px position-absoulte margin-top-2px">Card</label>

                                    </td>
                                    <td>
                                      <input type="text" class="form-control"
                                             min="1" max="10" *ngIf="card">
                                    </td>
                                    <td class="text-align-right">
                                      <input type="text" class="form-control"
                                             min="1" max="10" *ngIf="card">
                                    </td>

                                    <td class="td-padding ">

                                      <input type="text" class="form-control"
                                             min="1" max="10" *ngIf="card">

                                    </td>

                                    <td>
                                      <input type="text" class="form-control"
                                             min="1" max="10" *ngIf="card">
                                    </td>



                                  </tr>
                                  <tr>
                                    <td class="td-padding">


                                      <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                             [(ngModel)]="cheque" />
                                      <i class="input-helper"></i>
                                      <label class="margin-bottom-0px position-absoulte margin-top-2px">Cheque</label>

                                    </td>
                                    <td>
                                      <input type="text" class="form-control"
                                             min="1" max="10" *ngIf="cheque">
                                    </td>
                                    <td class="text-align-right">
                                      <input type="text" class="form-control"
                                             min="1" max="10" *ngIf="cheque">
                                    </td>

                                    <td class="td-padding ">

                                      <input type="text" class="form-control"
                                             min="1" max="10" *ngIf="cheque">

                                    </td>

                                    <td>
                                      <input type="text" class="form-control"
                                             min="1" max="10" *ngIf="cheque">
                                    </td>



                                  </tr>
                                  <tr>
                                    <td class="td-padding">

                                      <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                             [(ngModel)]="demanddraft" />
                                      <i class="input-helper"></i>
                                      <label class="margin-bottom-0px position-absoulte margin-top-2px">Demand Draft</label>

                                    </td>
                                    <td>
                                      <input type="text" class="form-control"
                                             min="1" max="10" *ngIf="demanddraft">
                                    </td>
                                    <td class="text-align-right">
                                      <input type="text" class="form-control"
                                             min="1" max="10" *ngIf="demanddraft">
                                    </td>

                                    <td class="td-padding ">

                                      <input type="text" class="form-control"
                                             min="1" max="10" *ngIf="demanddraft">

                                    </td>

                                    <td>
                                      <input type="text" class="form-control"
                                             min="1" max="10" *ngIf="demanddraft">
                                    </td>



                                  </tr>
                                  <tr>
                                    <td class="td-padding">

                                      <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                             [(ngModel)]="paytm" />
                                      <i class="input-helper"></i>
                                      <label class="margin-bottom-0px position-absoulte margin-top-2px">Paytm</label>

                                    </td>
                                    <td>
                                      <input type="text" class="form-control"
                                             min="1" max="10" *ngIf="paytm">
                                    </td>
                                    <td class="text-align-right">
                                      <input type="text" class="form-control"
                                             min="1" max="10" *ngIf="paytm">
                                    </td>

                                    <td class="td-padding ">

                                      <input type="text" class="form-control"
                                             min="1" max="10" *ngIf="paytm">

                                    </td>

                                    <td>
                                      <input type="text" class="form-control"
                                             min="1" max="10" *ngIf="paytm">
                                    </td>



                                  </tr>
                                </tbody>

                              </table>

                            </div>
                          </div>
                        </div>

                    </div>
                                           </div>






                </div>
              </div>
            </div>-->
          </div>
        </div>
        <!--<div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div class="card">


              <div class="card-header wh-header border-bottom padding-bottom-0px">
                <div class="row border-bottom">
                  <div class="col-md-4">
                    <label class="margin-bottom-0px">Discount : </label>
                  </div>
                  <div class="col-md-4">
                    <label class="margin-bottom-0px">Discount(%) :</label>
                  </div>
                  <div class="col-md-4">
                    <label class="margin-bottom-0px">Total :</label>
                  </div>
                </div>
              </div>






            </div>
          </div>
        </div>-->




      </div>
    </div>

    <div class="columnbp3 background-white ">

      <div class="position-fixed-Activities4">

        <div class="card" *ngIf="AdmissionHeader2 && !AdmissionHeader2.IsDischarged">
          <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px padding-t-6px padding-left-8px">
            <div class="row">
              <div class="col-md-12 font-size-12px">
                Services
              </div>
              <!--<div class="col-md-12 line-height-10px">
                <label class="margin-bottom-0px font-size-12px color-Assign" *ngIf="StoreName">({{StoreName}})</label>
              </div>-->
            </div>

            <div class="row margin-top-5px margin-bottom-10px margin-left-0px">
              <div class="col-md-12 padding-left-0px display-inherit padding-right-0px">
                <!--<search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>-->

                <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>

              </div>



            </div>
          </div>
          <div class="card-body padding-top-0px padding-left-0px padding-right-0px padding-bottom-0px margin-left-0px">

            <div class="chatsd product-chart-wrapper product-chat-height-600 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
              <div class="table-component actor-table">

                <div class="table-responsive padding-right-11px">


                  <table class="table table-striped table2">
                    <tbody>
                      <tr *ngFor="let l of pdata">
                        <td class="td-padding-2px">

                          <div class="row margin-left-zero margin-right"
                               (click)="AddServices(l)">                               
                            <div class="col-md-2  margin-tb-auto padding-right-0px padding-left-0px">
                              <button type="button"
                                      class="btn  btn-sm plus-button " id="FileUpload"
                                      name="upload">
                                <i class="fas fa-plus font-size-11p"></i>
                              </button>
                            </div>
                            <div class="col-md-10 margin-tb-auto padding-left-0px">
                              <label class="margin-bottom-0px color3">{{l.ServiceName}}</label>

                            </div>
                          </div>


                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
              </div>
            </div>




          </div>
        </div>
      </div>





    </div>


  </div>


  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>

<!--<div class="row" *ngIf="Formedit">
  <div class="col-md-8 padding-left-0px">


    <div class="card">

      <div class="card-body padding-all-0px">
        <div *ngIf="FormData" class="margin-top-10">


          <div class="row card margin-left-0px margin-right-0px margin-bottom-5px" *ngFor="let l of FormData;let RowIndex = index">

            <div [id]="'accordion'+RowIndex">
              <div class="card-header wh-header font-size-16px  padding-top-6px padding-bottom-6px card-header-bg border-left-clinical padding-l-8px padding-right-8px font-weight-normal2 font-size-16px" [id]="'heading'+RowIndex">
                <div class="row">
                  <div class="col-md-3">
                    <h5 class="mb-0">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" [attr.data-target]="'#collapse_cre'+RowIndex"
                              aria-expanded="true" [attr.aria-controls]="'collapse_cre'+RowIndex">
                        {{l.Title}}

                      </button>

                    </h5>
                  </div>
                  <div class="col-md-9">
                    <button type="submit" class="btn actions-btn-prime float-right">Save</button>
                    <button type="button"
                            (click)="Backtolist()" class="btn actions-btn-prime nav-link-hand button-Schedule actions-btn-prime3 float-right margin-right-10px">
                      Cancel
                    </button>
                  </div>
                </div>


              </div>
              <div [id]="'collapse_cre'+RowIndex" class="collapse show collapse-show3" [attr.aria-labelledby]="'heading'+RowIndex"
                   [attr.data-parent]="'#accordion'+RowIndex">
                <div class="card-body padding-bottom-19px padding-right-0px padding-top-0px">

                  <div class="row col-md-12 card" *ngFor="let f of l.Fields">


                    <div class="card-header wh-header font-size-14 padding-l-8px padding-t-6px padding-bottom-0px padding-right-0px" *ngIf="f.isHeader">
                      {{f.Title}}
                    </div>
                    <div class="card-body padding-bottom-0px padding-top-0px margin-left-zero">
                      <div *ngIf="f.isSubHeader">
                        <label class="font-size-14 margin-bottom-0px">{{f.Title}}</label>
                      </div>


                      <div *ngIf="f.isTextField">
                        <div class="row form-group">
                          <div class="col-md-3 padding-right-0px text-align-right">
                            <label class="font-size-12px margin-bottom-0px margin-top-10">{{f.Title}}</label>
                          </div>
                          <div class="col-md-3">
                            <input type="text" class="form-control" placeholder="Value" required maxlength="100" minlength="1">
                          </div>
                        </div>


                      </div>
                      <div *ngIf="f.isSubChild">
                        <div class="row form-group">
                          <div class="col-md-3 text-align-right">
                            <label class="font-size-12px margin-bottom-0px margin-top-10">{{f.Title}}</label>
                          </div>:
                          <div class="col-md-3">
                            <input type="text" class="form-control" placeholder="Value" required maxlength="100" minlength="1">
                          </div>
                        </div>
                      </div>


                      <div *ngIf="f.Remarks">
                        <label class="margin-left-10px margin-bottom-0px">{{f.Remarks}}</label>
                      </div>
                      <div *ngIf="f.HasSeparator">
                        <div class="border-bottom-light"></div>
                      </div>
                    </div>
                  </div>



                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4">

  </div>
</div>-->
<!--<div class="row">
  <div class="col-md-12">
    <medicalrecordview [FormattedCode]="FormattedCode" *ngIf="viewhealthrecord"></medicalrecordview>
  </div>

</div>-->
